export default __webpack_public_path__ + "ada9aef591189ff4303f941ef6c05c59.svg";